import { render, staticRenderFns } from "./DetailedChangelog.vue?vue&type=template&id=18bb7b69&"
import script from "./DetailedChangelog.vue?vue&type=script&lang=js&"
export * from "./DetailedChangelog.vue?vue&type=script&lang=js&"
import style0 from "./DetailedChangelog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports